import { observable, action, computed } from "mobx";
import { post } from "../services/ajax.service";

class PhysicianStore {
  @observable physicians = [];
  @observable drugs = [];
  @observable claims = [];
  @observable physician_count = 0;
  @observable url = "/api/v1/dataactions/physicians";
  @observable filterValue = "";

  // @computed get num_physicians() {
  //   let count = 0;
  //   if (this.physicians.length > 0) {
  //     for (let physician of this.physicians) {
  //       let total_spend = parseInt(physician.TOTAL_PLAN_SPEND);
  //       if (total_spend > 10000) {
  //         count += 1;
  //       }
  //     }
  //   }
  //   return count;
  // }
  @computed get tiles() {

    return parseInt(this.physician_count / 100) > 0 ? parseInt(this.physician_count / 100) + 1 : 0;
  }

  @action sortbyasc(filter) {
    this.filterValue = filter;
    if (this.physicians.length > 0) {

      if (filter == "total_cost") {
        this.physicians = this.physicians.sort(function (a, b) {
          if (parseInt(a.claim_cost) < parseInt(b.claim_cost)) return -1;
          if (parseInt(a.claim_cost) > parseInt(b.claim_cost)) return 1;
          return 0
        })
      }

      if (filter == "first_name") {
        this.physicians = this.physicians.sort(function (a, b) {
          if (a.first_name < b.first_name) return -1;
          if (a.first_name > b.first_name) return 1;
          return 0
        })
      }

      if (filter == "plan_pay") {
        this.physicians = this.physicians.sort(function (a, b) {
          if (parseInt(a.TOTAL_PLAN_SPEND) < parseInt(b.TOTAL_PLAN_SPEND)) return -1;
          if (parseInt(a.TOTAL_PLAN_SPEND) > parseInt(b.TOTAL_PLAN_SPEND)) return 1;
          return 0
        })
      }

      if (filter == "co_pay") {
        this.physicians = this.physicians.sort(function (a, b) {
          if (parseInt(a.co_pay) < parseInt(b.co_pay)) return -1;
          if (parseInt(a.co_pay) > parseInt(b.co_pay)) return 1;
          return 0

        })
      }
    }
    if (this.drugs.length > 0) {
      if (filter == "label_name") {
        this.drugs = this.drugs.sort(function (a, b) {
          if ((a.label_name) < (b.label_name)) return -1;
          if ((a.label_name) > (b.label_name)) return 1;
          return 0
        })
      }
      if (filter == "TOTAL_COST") {
        this.drugs = this.drugs.sort(function (a, b) {
          if (parseInt(a.TOTAL_COST) < parseInt(b.TOTAL_COST)) return -1;
          if (parseInt(a.TOTAL_COST) > parseInt(b.TOTAL_COST)) return 1;
          return 0
        })
      }
      if (filter == "plan_pay") {
        this.drugs = this.drugs.sort(function (a, b) {
          if (parseInt(a.plan_pay) < parseInt(b.plan_pay)) return -1;
          if (parseInt(a.plan_pay) > parseInt(b.plan_pay)) return 1;
          return 0
        })
      }
      if (filter == "co_pay") {
        this.drugs = this.drugs.sort(function (a, b) {
          if (parseInt(a.co_pay) < parseInt(b.co_pay)) return -1;
          if (parseInt(a.co_pay) > parseInt(b.co_pay)) return 1;
          return 0
        })
      }
      if (filter == "claims_count") {
        this.drugs = this.drugs.sort(function (a, b) {
          if (parseInt(a.claims_count) < parseInt(b.claims_count)) return -1;
          if (parseInt(a.claims_count) > parseInt(b.claims_count)) return 1;
          return 0
        })
      }
      if (filter == "life_id") {
        this.drugs = this.drugs.sort(function (a, b) {
          if (parseInt(a.life_id) < parseInt(b.life_id)) return -1;
          if (parseInt(a.life_id) > parseInt(b.life_id)) return 1;
          return 0
        })
      }
      if (filter == "type") {
        this.drugs = this.drugs.sort(function (a, b) {
          if ((a.type) < (b.type)) return -1;
          if ((a.type) > (b.type)) return 1;
          return 0
        })
      }
      if (filter == "pharmacy_name") {
        this.drugs = this.drugs.sort(function (a, b) {
          if ((a.pharmacy_name) < (b.pharmacy_name)) return -1;
          if ((a.pharmacy_name) > (b.pharmacy_name)) return 1;
          return 0
        })
      }

    }
  }

  @action sortbydesc(filter) {
    this.filterValue = filter;
    if (this.physicians.length > 0) {

      if (filter == "total_cost") {
        this.physicians = this.physicians.sort(function (a, b) {
          if (parseInt(a.claim_cost) > parseInt(b.claim_cost)) return -1;
          if (parseInt(a.claim_cost) < parseInt(b.claim_cost)) return 1;
          return 0
        })
      }

      if (filter == "first_name") {
        this.physicians = this.physicians.sort(function (a, b) {
          if (a.first_name > b.first_name) return -1;
          if (a.first_name < b.first_name) return 1;
          return 0
        })
      }

      if (filter == "plan_pay") {
        this.physicians = this.physicians.sort(function (a, b) {
          if (parseInt(a.TOTAL_PLAN_SPEND) > parseInt(b.TOTAL_PLAN_SPEND)) return -1;
          if (parseInt(a.TOTAL_PLAN_SPEND) < parseInt(b.TOTAL_PLAN_SPEND)) return 1;
          return 0
        })
      }

      if (filter == "co_pay") {
        this.physicians = this.physicians.sort(function (a, b) {
          if (parseInt(a.co_pay) > parseInt(b.co_pay)) return -1;
          if (parseInt(a.co_pay) < parseInt(b.co_pay)) return 1;
          return 0

        })
      }
    }
    if (this.drugs.length > 0) {
      if (filter == "label_name") {
        this.drugs = this.drugs.sort(function (a, b) {
          if ((a.label_name) > (b.label_name)) return -1;
          if ((a.label_name) < (b.label_name)) return 1;
          return 0
        })
      }
      if (filter == "TOTAL_COST") {
        this.drugs = this.drugs.sort(function (a, b) {
          if (parseInt(a.TOTAL_COST) > parseInt(b.TOTAL_COST)) return -1;
          if (parseInt(a.TOTAL_COST) < parseInt(b.TOTAL_COST)) return 1;
          return 0
        })
      }
      if (filter == "plan_pay") {
        this.drugs = this.drugs.sort(function (a, b) {
          if (parseInt(a.plan_pay) > parseInt(b.plan_pay)) return -1;
          if (parseInt(a.plan_pay) < parseInt(b.plan_pay)) return 1;
          return 0
        })
      }
      if (filter == "co_pay") {
        this.drugs = this.drugs.sort(function (a, b) {
          if (parseInt(a.co_pay) > parseInt(b.co_pay)) return -1;
          if (parseInt(a.co_pay) < parseInt(b.co_pay)) return 1;
          return 0
        })
      }
      if (filter == "claims_count") {
        this.drugs = this.drugs.sort(function (a, b) {
          if (parseInt(a.claims_count) > parseInt(b.claims_count)) return -1;
          if (parseInt(a.claims_count) < parseInt(b.claims_count)) return 1;
          return 0
        })
      }
      if (filter == "life_id") {
        this.drugs = this.drugs.sort(function (a, b) {
          if (parseInt(a.life_id) > parseInt(b.life_id)) return -1;
          if (parseInt(a.life_id) < parseInt(b.life_id)) return 1;
          return 0
        })
      }
      if (filter == "type") {
        this.drugs = this.drugs.sort(function (a, b) {
          if ((a.type) > (b.type)) return -1;
          if ((a.type) < (b.type)) return 1;
          return 0
        })
      }
      if (filter == "pharmacy_name") {
        this.drugs = this.drugs.sort(function (a, b) {
          if ((a.pharmacy_name) > (b.pharmacy_name)) return -1;
          if ((a.pharmacy_name) < (b.pharmacy_name)) return 1;
          return 0
        })
      }
    }
  }






  @action getPhysicianCount = async data => {
    this.physicians = [];
    this.drugs = [];
    this.claims = []
    try {
      let response = await post(
        `${this.url}/getPhysicianCount`,
        data
      );

      this.physician_count = response.data[0].physician_count;
    } catch (err) {
      console.log(err);
    }
  };
  @action getPhysicians = async data => {
    this.physicians = [];
    this.drugs = [];
    this.claims = []
    try {
      let response = await post(
        `${this.url}/getPhysicians`,
        data
      );

      this.physicians = response.data;
    } catch (err) {
      console.log(err);
    }
  };

  @action getDrugs = async data => {
    this.drugs = [];
    this.claims = []
    try {
      let response = await post(
        `${this.url}/getDrugs`,
        data
      );

      this.drugs = response.data;
    } catch (err) {
      console.log(err);
    }
  };

  @action getClaims = async data => {
    try {
      let response = await post(
        `${this.url}/getClaims`,
        data
      );

      this.claims = response.data;
    } catch (err) {
      console.log(err);
    }
  };
}

export default PhysicianStore;
